import { DP_PORTAL_SUBTITLE, DP_PORTAL_TITLE } from '../../dpPortal.definitions';
import { DpPortalTabNav } from '../DpPortalTabNav';

export function DpPortalHeader() {
    return (
        <header className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="min-w-0">
                <h1 className="font-montserrat text-3xl font-bold text-raro-gray-900 sm:text-4xl">
                    {DP_PORTAL_TITLE}
                </h1>
                <p className="mt-1 font-montserrat text-sm text-raro-gray-500">{DP_PORTAL_SUBTITLE}</p>
            </div>
            <DpPortalTabNav />
        </header>
    );
}
